<template>
  <div>
    <div v-if="showModal">
      <!-- {{showModal}} -->
      <Preview
        :showModal="showModal"
        @showModalUpdate="setShowModal($event)"
        :previewData="previewData"
      />
    </div>

    <vk-offcanvas flipped overlay stuck :show.sync="editOffCanvas">
      <div style="height: 100%;">
        <vk-offcanvas-close @click="toggleEdit"></vk-offcanvas-close>
        <h3>Edit</h3>
        <hr />
        <div>
          <form>
            <div class="form-group" style="padding: 0;">
              <label style="text-align: left; padding: 0;" for="deviceID"
                >Installation</label
              >
              <el-autocomplete
                style="width: 100%;"
                id="customer-contact"
                class="inline-input"
                v-model="form.installation"
                :fetch-suggestions="installationSearch"
                placeholder="Search contact"
                prefix-icon="el-icon-search"
                @select="contactSelected"
              ></el-autocomplete>
            </div>
            <div
              class="form-group"
              style="display: flex; flex-flow: column; padding: 0;"
            >
              <label style="text-align: left; padding: 0;" for="filterDate"
                >Contract Period</label
              >
              <el-date-picker
                style="width: 100%;"
                v-model="form.filterDate"
                type="datetimerange"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date"
                align="center"
              ></el-date-picker>
            </div>
            <div class="form-group" style="display: flex; flex-flow: row;">
              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-right: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="orderVat"
                  >VAT (%)</label
                >
                <el-select
                  v-model="form.orderVat"
                  placeholder="Select"
                  style="width: 100%;"
                >
                  <el-option
                    :key="`7_5_item_vat_list`"
                    :label="`7.5%`"
                    :value="7.5"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-left: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="orderVat"
                  >Payment Model</label
                >
                <el-select
                  v-model="form.paymentModel"
                  placeholder="Select Payment Model"
                  style="width: 100%;"
                  @change="noPaymentModelChange(form.paymentModel)"
                >
                  <el-option
                    :key="`5_item_paymentModel_list`"
                    :label="`LO`"
                    :value="`LO`"
                  ></el-option>
                  <el-option
                    :key="`7_item_paymentModel_list`"
                    :label="`ES`"
                    :value="`ES`"
                  ></el-option>
                </el-select>
              </div>

              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-left: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="sendDate"
                  >Send Date</label
                >
                <el-date-picker
                  style="width: 100%;"
                  v-model="form.sendDate"
                  type="datetime"
                  align="center"
                ></el-date-picker>
              </div>
            </div>
            <div class="form-group" style="display: flex; flex-flow: row;">
              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-right: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="amount"
                  >Amount
                </label>
                <el-input-number
                  style="width: 100%;"
                  id="customer-price"
                  v-model="form.amount"
                  :min="1"
                ></el-input-number>
              </div>
              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-left: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="amount"
                  >Installation Location</label
                >
                <el-input
                  placeholder="Location"
                  v-model="form.location"
                ></el-input>
              </div>
            </div>
            <div class="form-group">
              <label style="text-align: left; padding: 0;" for="title"
                >Title</label
              >
              <el-input
                v-model="form.title"
                placeholder="ARNERGY 5000 - ENERGY AS A SERVICE SUBSCRIPTION"
                id="title"
              ></el-input>
            </div>
            <div class="form-group">
              <label style="text-align: left; padding: 0;" for="description"
                >Description</label
              >
              <el-input
                type="textarea"
                :rows="2"
                v-model="form.description"
                placeholder="Design, Installation, Commissioning and Managed Service of a 4.5kWp Solar PV System with 10.8kWh Lithium-ion battery Storage"
                id="description"
              ></el-input>
            </div>
            <div class="form-group" style="display: flex; flex-flow: row;">
              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-right: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="description"
                  >Contact Address</label
                >
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="form.user.address"
                  placeholder="No 5, Apabio Str, Lagos, Nigeria"
                  id="address"
                ></el-input>
              </div>
              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-left: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="description"
                  >CC Emails</label
                >
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="form.user.ccEmails"
                  placeholder="me@arnergy.com, you@arnergy.com"
                  id="ccEmails"
                ></el-input>
              </div>
            </div>

            <div style>
              <button
                :disabled="loading"
                type="submit"
                @click="edit"
                class="btn btn-primary mb-2"
              >
                {{ loadingEdit ? "Loading..." : "Edit" }}
              </button>
              &nbsp; &nbsp;
              <!-- <button
                :disabled="loading"
                type="submit"
                @click="preview"
                class="btn btn-primary mb-2"
              >
                {{ loadingEdit ? "Loading..." : "Preview" }}
              </button> -->
              <button
                type="submit"
                class="btn btn-primary mb-2"
                @click="preview"
              >
                {{ previewLoading ? "Loading..." : "Preview" }}
              </button>
              &nbsp; &nbsp;
              <button
                :disabled="loading"
                type="submit"
                @click="deleteSub"
                class="btn btn-danger mb-2"
              >
                {{ loadingDel ? "Loading..." : "Delete" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </vk-offcanvas>
  </div>
</template>
<script>
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Autocomplete, Loading } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import Preview from "./preview";
export default {
  name: "edit-subs",
  props: {
    toggleEdit: {
      type: Function
    },
    editOffCanvas: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object
    },
    getSubs: {
      type: Function
    },
    installationList: {
      type: Array
    }
  },
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    Preview
  },
  computed: {
    ...mapGetters(["getUserSession"]),
    getCurrentMonth: function() {
      const date = moment().format("MMMM YYYY");
      return date;
    }
  },
  data: function() {
    return {
      loading: false,
      loadingDel: false,
      loadingEdit: false,
      previewOffCanvas: false,
      showModal: false,
      previewLoading: false,
      previewData: {}
    };
  },
  methods: {
    togglePreview() {
      let ctx = this;
      ctx.previewOffCanvas = !ctx.previewOffCanvas;
    },
    setShowModal(v) {
      this.showModal = v;
    },
    preview(e) {
      e.preventDefault();
      let ctx = this;
      const HTTP = ctx.$httpUtils.instance;

      let data = ctx.form;
      ctx.previewLoading = true;
      const url = `/subscriptionsMgr/preview/${this.getUserSession.id}/${data.id}`;
      HTTP.get(url)
        .then(response => {
          ctx.previewLoading = false;
          let { data } = response.data;
          console.log({ data });
          ctx.previewData = data;
          ctx.showModal = !ctx.showModal;
        })
        .catch(error => {
          ctx.previewLoading = false;
          console.log({ error });
        });
      return;
    },
    deleteSub(e) {
      e.preventDefault();
      let ctx = this;
      ctx.loading = true;
      ctx.loadingDel = true;
      const HTTP = ctx.$httpUtils.instance;
      let data = ctx.form;
      const url = `/subscriptionsMgr/${data.id}`;
      HTTP.delete(url)
        .then(response => {
          ctx.loading = false;
          ctx.loadingDel = false;
          ctx.getSubs();
          ctx.toggleEdit();
          console.log({ response });
        })
        .catch(error => {
          ctx.loading = false;
          ctx.loadingDel = false;

          var errorMsg = error.response.data.error.message;
          console.log(JSON.stringify(error));
          console.log({ errorMsg });
          alert(errorMsg);
        });
      console.log({ HERE: "Dlete" });
    },
    edit(e) {
      e.preventDefault();
      let ctx = this;
      if (
        ctx.form.installation == null ||
        ctx.form.amount < 5 ||
        ctx.form.location == undefined ||
        ctx.form.location == "" ||
        ctx.form.paymentModel == null ||
        ctx.form.user.address == undefined ||
        ctx.form.user.address == "" ||
        ctx.form.sendDate == undefined ||
        ctx.form.sendDate == "" ||
        ctx.form.filterDate == undefined ||
        ctx.form.filterDate.length < 2
      ) {
        alert("All fields are required");
        return;
      }
      ctx.loading = true;
      ctx.loadingEdit = true;
      const HTTP = ctx.$httpUtils.instance;
      console.log({ form: ctx.form });

      delete ctx.form.installation;
      let data = ctx.form;
      const url = `/subscriptionsMgr/${data.id}`;
      HTTP.put(url, data)
        .then(response => {
          ctx.loading = false;
          ctx.loadingEdit = false;
          ctx.getSubs();
          ctx.toggleEdit();
          console.log({ response });
        })
        .catch(error => {
          var errorMsg = error.response.data.error.message;
          ctx.loading = false;
          ctx.loadingEdit = false;

          console.log(JSON.stringify(error));
          console.log({ errorMsg });
          alert(errorMsg);
        });
    },
    installationSearch(queryString, cb) {
      let installationList = this.installationList;
      var results = queryString
        ? installationList.filter(installation =>
            this.createFilter(queryString, installation)
          )
        : installationList;
      cb(results);
    },
    noPaymentModelChange(paymentModel) {
      let ctx = this;

      ctx.form.description = ctx.getDescription(paymentModel);
      ctx.form.title = ctx.getTitle(paymentModel);
    },
    createFilter(queryString, installation) {
      return (
        `${installation.name} - ${installation.CID}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    contactSelected(installation) {
      // console.log({ installation });

      let ctx = this;
      let { form } = ctx;
      let { deviceRequest, user, locations } = installation;
      // console.log({ location: deviceRequest });

      let paymentModel = deviceRequest.paymentModel;
      if (paymentModel == "LO" || paymentModel == "ES") {
        form.paymentModel = paymentModel;
        form.description = ctx.getDescription(paymentModel);
        form.title = ctx.getTitle(paymentModel);
        form.userId = user.id;
        form.CID = installation.CID;
        form.installationId = installation.id;
        // User
        form.user.firstName = user.firstName;
        form.user.lastName = user.lastName;
        form.user.email = user.email; //
        form.user.ccEmails = user.ccEmails; //
        form.user.id = user.id; //
        // Location
        form.location =
          typeof locations == "undefined" ? "" : locations.streetRoute;

        ctx.form = form;
      } else {
        ctx.form = {
          amount: "",
          title: "",
          description: "",
          orderVat: "7.5",
          installation: null,
          paymentModel: "",
          ccEmails: "",
          user: {
            address: ""
          },
          filterDate: [],
          location: "",
          sendDate: ""
        };
        alert("Only ES and LO are Allowed");
      }
    },
    getDescription(paymentModel) {
      let desc = "";
      let md = paymentModel != null ? paymentModel.toUpperCase() : "";
      switch (md) {
        case "ES":
          desc = `Subscription for the month of ${this.getCurrentMonth}`;
          break;
        case "OS":
          desc = "OUTRIGHT SALE";
          break;
        case "LO":
          desc = `Repayment for the month of ${this.getCurrentMonth}`;
          break;
        default:
          desc = "MONTHLY SUBSCRIPTION";
          break;
      }
      return desc;
    },
    getTitle(paymentModel) {
      let title = "";
      let md = paymentModel != null ? paymentModel.toUpperCase() : "";
      switch (md) {
        case "ES":
          title = "ENERGY AS A SERVICE SUBSCRIPTION";
          break;
        case "OS":
          desc = "OUTRIGHT SALE";
          break;
        case "LO":
          title = "LEASE TO OWN REPAYMENT";
          break;
        default:
          desc = "MONTHLY SUBSCRIPTION";
          break;
      }
      return title;
    }
  },
  created() {
    let ctx = this;
  }
};
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-dialog {
  width: 50% !important;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/subsmanager/edit.vue